<template>
    <span>
        <editardiario></editardiario>
    </span>
</template>

<script>
import Editardiario from '@/components/Editar-Diario';

export default {
    name: 'cadeditardiario',
    components: {
        Editardiario
    }
};
</script>